module.exports = __webpack_public_path__ + "overview-a5b6df21/people-740e0233d92b7a9a7bf2f175bd069050.svg";